import { useMutation } from 'react-query'
import { useHistory } from 'react-router-dom'
import { routePaths } from 'global/routePaths'
import { endpoints } from 'global/endpoints'
import http from 'utils/http'
import { toast } from 'react-toastify'

const editEvents = ({ ...postData }) => {
  if (postData.id) {
    const updatedEndpoints = endpoints.events.base
    return http('multipart').put(updatedEndpoints, postData)
  }
}

export function useEditEvents() {
  const history = useHistory()

  return useMutation(editEvents, {
    onSuccess: () => {
      toast.success('Events has been edited successfully')
      history.push(routePaths.home.events.base)
    },
    onError: (err) => {
      console.log(err)
      toast.error('Unfortunately, update of events was not successful.')
    },
  })
}
